<template>
  <div>
    <zjhx-tx />
  </div>
</template>

<script>
// 获取接口地址
import zjhxTx from '@/components/tztx/zjhxTx'

export default {
  name: 'Zjhx',
  components: {
    zjhxTx
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
